export default __webpack_public_path__ + "static/media/A15.558ce8b2.png";